<template>
  <div class="mb-3">
    <b-form-checkbox :checked="includeReward" @change="$emit('toggle', $event)">
      <strong>{{ heading }}</strong>
      <br />
      <small class="text-muted">
        Enter the value they'll receive<template v-if="maxAwardValueMinor != null">
          (up to {{ formatAmount(maxAwardValueMinor) }})</template
        >
      </small>
    </b-form-checkbox>

    <div v-if="includeReward" class="mt-2 ml-4">
      <b-form-input
        :value="typedAwardAmount"
        type="number"
        min="0"
        step="0.01"
        inputmode="decimal"
        placeholder="0.00"
        @input="$emit('input', $event)"
      />
      <small v-if="error" class="text-danger">{{ error }}</small>
    </div>
  </div>
</template>

<script setup>
import { toCurrency } from '@/utils';

defineProps({
  // Checkbox heading: "Award value" (nominate) vs "Approve reward" (open).
  heading: {
    type: String,
    required: true,
  },
  includeReward: {
    type: Boolean,
    default: false,
  },
  typedAwardAmount: {
    type: [String, Number],
    default: '',
  },
  maxAwardValueMinor: {
    type: Number,
    default: null,
  },
  error: {
    type: String,
    default: '',
  },
});

defineEmits(['toggle', 'input']);

const formatAmount = amountMinor => toCurrency(amountMinor);
</script>
